<app-blog-shell [blogId]="'deployment-with-coolify'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.coolify.TITLE"></h1>
    <br>

    <h2 data-translate="BLOG.DETAILS.coolify.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.TLDR.BODY"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.coolify.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.SECTION1.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.coolify.SECTION2.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.SECTION2.P1"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.coolify.SECTION2.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.coolify.SECTION2.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.coolify.SECTION2.ITEM3"></li>
    </ul>
    <p data-translate="BLOG.DETAILS.coolify.SECTION2.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.coolify.SECTION3.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.SECTION3.P1"></p>

    <pre>
      <code class="language-yaml">
services:
  backend:
    build: ./backend
    depends_on: [db]
  frontend:
    build: ./frontend
    expose:
      - "80"
  db:
    image: postgres:15
  proxy:
    image: traefik
      </code>
    </pre>

    <p data-translate="BLOG.DETAILS.coolify.SECTION3.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.coolify.SECTION4.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.SECTION4.P1"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.coolify.SECTION4.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.coolify.SECTION4.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.coolify.SECTION4.ITEM3"></li>
      <li data-translate="BLOG.DETAILS.coolify.SECTION4.ITEM4"></li>
    </ul>

    <p data-translate="BLOG.DETAILS.coolify.SECTION4.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.coolify.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.coolify.CONCLUSION.P1"></p>
    <p data-translate="BLOG.DETAILS.coolify.CONCLUSION.P2"></p>
  </div>
  <br>
</app-blog-shell>
